<template>
  <div>
    <div v-if="needsCityAccountForm"><br/>
      <h4 class="pt-4">Required Bountiful Utility information</h4>
      <p style="max-width:640px">
        Bountiful Fiber customers must enter their Account Number and Customer ID from their <a href="https://www.bountifulutah.gov/Utilities1" target="_blank"><b>Bountiful Utility account</b></a>.
        These numbers can be found on your <a id="utility-bill-btn" class="btn btn-outline-primary" @click="show_utility_bill = !show_utility_bill"><b>utility bill</b></a>
        <transition v-on:enter="scrolldown('sample-utility-bill')">
          <div v-show="show_utility_bill" id="sample-utility-bill">
            <br/>
            <img src="https://asset.xmission.com/xmweb3/btfl-utility-sample.png" alt="Sample Utility Bill">
          </div>
        </transition>
      </p>
      <div class="row mt-2">
        <div class="col-md-4">
          Bountiful Utility Account Number<br />
          <xm-input class="mb-3" v-model="form_data.city_account_id" :pattern="city_account_id_regex" required error="Enter account ID" :maxlength="30"/>
        </div>
        <div class="col-md-4">
          Bountiful Utility Customer ID<br />
          <xm-input class="mb-3" v-model="form_data.city_customer_id" :pattern="city_customer_id_regex" required error="Enter a valid integer" :maxlength="10"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import ConnectivityService from '../../../lib/ssu/input_models/connectivity-service';
  import XmInput from "../../XmInput.vue";
  import helpers from "../../../lib/helpers";

  export default {
    components: {
      XmInput
    },

    data () {
      return {
        form_data: {
          city_customer_id: '',
          city_account_id: '',
        },
        city_customer_id_regex: /^[1-9][0-9]{1,10}$/,  // must be a valid integer
        city_account_id_regex: /^[0-9]{1,30}$/,  // must be numeric with padded leading zeros up to 30 chars long,
        show_utility_bill: false,  // show the utility bill image,
        scrolldown: helpers.scrolldown
      }
    },

    mounted () {
      // we do this since the component is empty
      this.$emit('form-state', this.serviceReady);
    },

    props: {
      value: {
        required: false,
        default: () => {}
      },
      // service should be an instance of ConnectivityService
      service: {
        required: true,
        type: ConnectivityService
      }
    },

    computed: {
      needsCityAccountForm () {
        return this.service.service_class_model.service_class_id === 8;  // Bountiful
      },
      serviceSubmissionData () {
        return this.form_data;
      },
      serviceReady() {
        if (!this.needsCityAccountForm) {
          return true;  // no form needed
        }
        // check if the form is valid
        return this.form_data.city_customer_id.match(this.city_customer_id_regex) &&
               this.form_data.city_account_id.match(this.city_account_id_regex);
      },
    },

    watch : {
      serviceSubmissionData: {
        handler (new_val) {
          this.$emit('input', new_val);
        },
        deep: true
      },
      serviceReady (new_val) {
        new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
        this.$emit('form-state', new_val);
      }
    },
  }
</script>

<style scoped>
#sample-utility-bill img {
  max-width:100%;
  box-shadow:-5px -5px 15px #ddd;
  border-top:1px solid #ccc;
  border-left:1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// UtopiaResidential.vue?54ad57ed